/**
 * The BaseViewObject class acts as the base one for the common usage.
 */
const tbs_model_vo_BaseViewObject = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_BaseViewObject.prototype = {
    /* The default value for the max number */
    MAX_NUM: 9999999,
    /* The default value for the start date */
    START_DATE: '1900-01-01',
    /* The default value for the end date */
    END_DATE: '2199-12-31',
    /* The default value for the start date time */
    START_DATE_TIME: '1900-01-01T00:00:00+0800',
    /* The default value for the end date time */
    END_DATE_TIME: '2199-12-31T23:59:59+0800',
    //--------------------------------------------------
    // protected method
    //--------------------------------------------------
    _renderMaxNum: function(maxNum) {
        if (maxNum === this.MAX_NUM) {
            maxNum = 0
        }
        return maxNum
    },
    _formatMaxNum: function(maxNum) {
        if (maxNum === 0) {
            maxNum = this.MAX_NUM
        }
        return maxNum
    },
    _renderStartDate: function(startDate) {
        if (startDate === this.START_DATE) {
            startDate = ''
        }
        return startDate
    },
    _formatStartDate: function(startDate) {
        if (!startDate) {
            startDate = this.START_DATE
        }
        return startDate
    },
    _renderEndDate: function(endDate) {
        if (endDate === this.END_DATE) {
            endDate = ''
        }
        return endDate
    },
    _formatEndDate: function(endDate) {
        if (!endDate) {
            endDate = this.END_DATE
        }
        return endDate
    },
    _renderStartDateTime: function(startDateTime) {
        if (startDateTime === this.START_DATE_TIME) {
            startDateTime = ''
        }
        return startDateTime
    },
    _formatStartDateTime: function(startDateTime) {
        if (!startDateTime) {
            startDateTime = this.START_DATE_TIME
        }
        return startDateTime
    },
    _renderEndDateTime: function(endDateTime) {
        if (endDateTime === this.END_DATE_TIME) {
            endDateTime = ''
        }
        return endDateTime
    },
    _formatEndDateTime: function(endDateTime) {
        if (!endDateTime) {
            endDateTime = this.END_DATE_TIME
        }
        return endDateTime
    },
}

module.exports = tbs_model_vo_BaseViewObject